import { useTheme } from '../../context/ThemeContext';

const Logo = ({ size = 'default', showText = true, layout = 'horizontal', variant = 'sidebar' }) => {
    const { theme } = useTheme();

    const sizes = {
        small: { iconHeight: 120 },
        default: { iconHeight: 80 },
        large: { iconHeight: 180 },
    };

    const { iconHeight } = sizes[size] || sizes.default;
    const isVertical = layout === 'vertical';
    const isAuth = variant === 'auth';

    // SVG variant par thème (couleurs intégrées dans chaque fichier SVG)
    const getLogoSrc = () => {
        switch (theme) {
            case 'girly':
                return '/logoDailyDeen-girly.svg';
            case 'neutral':
                return '/logoDailyDeen-neutral.svg';
            default:
                return '/logoDailyDeen.svg';
        }
    };

    // Couleurs du texte adaptées au contexte
    const textDailyColor = isAuth ? 'var(--primary-color)' : 'var(--text-light)';
    const textDeenColor = 'var(--secondary-color)';
    const swooshPrimaryStroke = isAuth ? 'var(--primary-color)' : 'var(--text-light)';

    return (
        <div
            className="logo-wrapper"
            style={{
                display: 'flex',
                flexDirection: isVertical ? 'column' : 'row',
                alignItems: 'center',
                gap: showText ? (isVertical ? '4px' : '10px') : '0',
            }}
        >
            {/* Logo SVG image */}
            <img
                src={getLogoSrc()}
                alt="DailyDeen logo"
                height={iconHeight}
                width={iconHeight}
            />

            {/* Text + Swoosh */}
            {showText && (
                <div style={{ textAlign: 'center' }}>
                    <span className="logo-text" style={{ color: textDailyColor }}>
                        daily<span style={{ color: textDeenColor }}>Deen</span>
                    </span>
                    {isVertical && (
                        <svg
                            viewBox="0 0 130 18"
                            style={{ display: 'block', width: '100%', marginTop: '-2px' }}
                            aria-hidden="true"
                        >
                            <path
                                d="M 5,6 Q 35,17 65,14"
                                stroke={swooshPrimaryStroke}
                                strokeWidth="2.2"
                                fill="none"
                                strokeLinecap="round"
                            />
                            <path
                                d="M 65,14 Q 95,11 122,4"
                                stroke={textDeenColor}
                                strokeWidth="2.2"
                                fill="none"
                                strokeLinecap="round"
                            />
                            <circle cx="123" cy="3.5" r="2.8" fill={textDeenColor} />
                        </svg>
                    )}
                </div>
            )}
        </div>
    );
};

export default Logo;
